import React, { FC } from 'react';
import classNames from 'classnames';
import styles from './index.module.scss';
import { SidebarView } from 'src/shared';
import { SidebarMode } from 'src/shared/InfoSidebar/types';
import { useCurrentSidebar } from 'src/shared/InfoSidebar/hooks';
import TenderPreview from 'src/pages/TendersPage/Sidebars/TenderPreview';
import { useApiTenders } from 'src/models/procurements/Tenders/hooks';

export const BuyerTenderPreview: FC = () => {
  const sidebarState = useCurrentSidebar();
  const [{ data: apiTenders }] = useApiTenders();

  return sidebarState && apiTenders ? (
    <SidebarView
      className={classNames(styles.sidebar, {
        [styles.isOpen]: !!sidebarState
      })}
    >
      {sidebarState.mode === SidebarMode.PROCUREMENT_INFO && sidebarState.id && (
        <TenderPreview tenderId={sidebarState.id} />
      )}
    </SidebarView>
  ) : (
    <></>
  );
};

export default BuyerTenderPreview;
